module.exports = __webpack_public_path__ + "img/column_logo@2x.14a4d776.png";